import React from 'react';
import { graphql } from 'react-apollo';
import Select from '../../../components/Select';
import ALL_THEATERS_QUERY from '../../../graphql/AllTheaters';

class SelectTheaterField extends React.PureComponent {
  render() {
    const options = [];

    if (this.props.theaters) {
      this.props.theaters.forEach((v) => {
        options.push({ value: v.id, label: v.name });
      });
    }

    return (
      <Select
        name="theater"
        placeholder="Teatro"
        isLoading={this.props.loading}
        options={options}
      />
    );
  }
}

const withTheaters = graphql(ALL_THEATERS_QUERY, {
  options: () => ({
    fetchPolicy: 'cache-and-network',
  }),
  props: ({ data }) => ({
    loading: data.loading,
    theaters: data.allTheaters,
  }),
});

export default withTheaters(SelectTheaterField);



// WEBPACK FOOTER //
// ./src/containers/Others/SelectTheaterField/index.js